import { VitalRow } from "../../api/vital.type";
import MedicalRecordSummaryCard from "../medical-records/medical-record-summary-card";
import { formatTimeStampToHumanReadableDate } from "../utls/time";
import { pickRecordValue } from "#/lib/medicalRecords";

type VitalSummaryCardProps = {
  vital: VitalRow;
  onClick?: () => void;
};

const formatDate = (value?: string | null) => {
  if (!value) return undefined;
  try {
    return formatTimeStampToHumanReadableDate(value);
  } catch {
    return undefined;
  }
};

export function VitalSummaryCard({ vital, onClick }: VitalSummaryCardProps) {
  const title =
    pickRecordValue<string>(vital as any, ["vital_sign_type", "vitalSignType"]) ||
    "Vital sign";

  const value = pickRecordValue<string>(vital as any, [
    "vital_sign_value",
    "vitalSignValue",
  ]);
  const unit = pickRecordValue<string>(vital as any, [
    "vital_sign_unit",
    "vitalSignUnit",
  ]);
  const subtitle = value ? [value, unit].filter(Boolean).join(" ") : undefined;

  const status = pickRecordValue<string>(vital as any, [
    "vital_sign_interpretation",
    "vitalSignInterpretation",
  ]);

  const meta = [
    {
      label: "Range",
      value: pickRecordValue<string>(vital as any, [
        "vital_sign_range",
        "vitalSignRange",
      ]),
    },
    {
      label: "Updated",
      value: formatDate(
        pickRecordValue<string>(vital as any, ["updated_at", "updatedAt"])
      ),
    },
  ];

  return (
    <MedicalRecordSummaryCard
      title={title}
      subtitle={subtitle}
      status={status}
      statusTone={status ? "info" : "default"}
      meta={meta}
      onClick={onClick}
    />
  );
}

export default VitalSummaryCard;
